<template>
  <ion-page>
    <!-- <ion-header> Esto al parecer no hace falta. Revisar si es cierto que se puede convivir sin esto
      <ion-toolbar>
        <ion-title>Seleccionar artículo</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="cerrar">Cerrar</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header> -->
    <ion-content>
      <SeleccionProductoStockComponent
        :origen="eventoSeleccion"
        :input_inicial_filtro="filtroInicial"
      />
    </ion-content>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue'
import { IonPage, IonContent, modalController } from '@ionic/vue'
import SeleccionProductoStockComponent from '@/components/search/seleccion-producto-stock-component.vue'
import eventBus from '@/event-bus'

export default defineComponent({
  name: 'InventarioSeleccionProductoModal',
  components: { IonPage, IonContent, SeleccionProductoStockComponent },
  props: {
    filtroInicial: { type: String, default: '' }
  },
  data () {
    return {
      eventoSeleccion: 'inventario-seleccion-producto-modal:seleccion'
    }
  },
  mounted () {
    eventBus().emitter.on(this.eventoSeleccion, async (item) => {
      if (item && item.sku) {
        await modalController.dismiss({ item }, 'confirm')
        return
      }
      await modalController.dismiss(null, 'cancel')
    })
  },
  methods: {
    async cerrar () {
      await modalController.dismiss(null, 'cancel')
    }
  }
})
</script>

<style scoped>
</style>